import React, { useEffect } from 'react';
import { Redirect } from 'react-router';
import { useActions, useAuthenticatedSocket, useDeviceGroups, useEmitFetchData } from '../Api/newSockets.api';

const Test = () => {

    const { deviceGroups } = useDeviceGroups();
    // const { actions } = useActions();

    // const { authSocket, connected, error } = useAuthenticatedSocket();

    
    return (<div>{JSON.stringify(deviceGroups)}</div>)
}

export default Test